import { useState } from "react";
import {
  buscarProcurasSemCompatibilidadesService,
  type BuscarProcurasSemCompatibilidadesResponse,
} from "../../../services/buscarProcurasSemCompatibilidadesService";
import {
  montarProcurasSemCompatibilidades,
  resumirProcurasSemCompatibilidades,
  type ProcuraSemCompatibilidade,
  type TotaisSemCompatibilidade,
} from "../utils/compatibilidades";

const totaisIniciais: TotaisSemCompatibilidade = {
  total: 0,
  totalINT: 0,
  totalPOST: 0,
};

export const useBuscarProcurasSemCompatibilidades = () => {
  const [procurasSemCompatibilidade, setProcurasSemCompatibilidade] = useState<
    ProcuraSemCompatibilidade[]
  >([]);
  const [totaisSemCompatibilidade, setTotaisSemCompatibilidade] =
    useState<TotaisSemCompatibilidade>(totaisIniciais);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const resetError = () => setError(null);

  const buscarProcurasSemCompatibilidade = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const data =
        (await buscarProcurasSemCompatibilidadesService()) as
          | BuscarProcurasSemCompatibilidadesResponse
          | false;

      if (!data) {
        setProcurasSemCompatibilidade([]);
        setTotaisSemCompatibilidade(totaisIniciais);
        setError(
          "Nao foi possivel buscar as procuras sem compatibilidades no momento."
        );
        return false;
      }

      const procuras = await montarProcurasSemCompatibilidades(
        Array.isArray(data.procuras) ? data.procuras : []
      );
      const totaisCalculados = resumirProcurasSemCompatibilidades(procuras);

      setProcurasSemCompatibilidade(procuras);
      setTotaisSemCompatibilidade(totaisCalculados);

      return true;
    } catch (error) {
      console.error("Erro ao buscar procuras sem compatibilidades:", error);
      setProcurasSemCompatibilidade([]);
      setTotaisSemCompatibilidade(totaisIniciais);
      setError(
        "Nao foi possivel buscar as procuras sem compatibilidades no momento."
      );
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    buscarProcurasSemCompatibilidade,
    procurasSemCompatibilidade,
    totaisSemCompatibilidade,
    isLoading,
    error,
    resetError,
  };
};
